module.exports = __webpack_public_path__ + "img/logo.f41c6372.png";